export default __webpack_public_path__ + "static/media/normalize.1444247f.css";